import {DetectionNotificationProps, DetectionPatient} from "@/notification/interfaces";
import {UserSettings} from "@/settings/interfaces";
import {detectionApi} from "@/container";
import {Program} from "@/program/interfaces/Program";

export type DetectionDriverSlug = 'cardless' | 'sesam-vitale' | 'live';

const useCustomerDetectionIpcEvents = () => {
    /**
     * Get the preview detection item.
     *
     * @param settings
     */
    const previewItem = (settings: UserSettings) => {
        const patient = {
            nir: '170000000000000',
            lastName: 'au comptoir',
            firstName: 'Patient',
            birthDate: '01011980'
        };

        const exampleProgram = {
            id: 1,
            name: "Programme exemple",
            teaser: "Recommandations du programme"
        } as Program;

        const item: DetectionNotificationProps = {
            patient,
            customer: {
                id: 0,
                customer_id: 0,
                type: "customer",
                nir: "170000000000000",
                information: {
                    first_name: 'Patient',
                    last_name: 'au comptoir',
                    birth_date: '01011980',
                    gender: 1,
                    name: 'Patient au comptoir',
                },
                statistics: null,
                healthcenter: null,
                key: 'c_0',
                programs: [
                    exampleProgram,
                    {
                        ...exampleProgram,
                        id: 2
                    },
                    {
                        ...exampleProgram,
                        id: 3
                    }
                ],
                beneficiaries: [],
            },
            settings,
            loyalty_cards: [],
            certified: false,
            certification_status: 'pre-certified',
            fraud_report: undefined,
            polls: []
        };

        return item;
    };

    /**
     * Reset the patient detection.
     *
     * @param patient  The patient information
     * @param hostname  The hostname of the detection service
     * @param driver  The detection driver used
     */
    const resetPatient = (patient: DetectionPatient, hostname: string, driver: DetectionDriverSlug) => {
        detectionApi().create(hostname, patient, false, driver).catch(() => null);
    };

    return {
        resetPatient,
        previewItem,
    };
};

export default useCustomerDetectionIpcEvents;
